import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Grid,
  TextField
} from '@material-ui/core';
import { Formik } from 'formik';
import * as yup from 'yup';
import NumberFormat from 'react-number-format';
import { BackdropCircular, BackTo } from 'components';
import { sendDirectFulfillmentRequestApi } from 'api';


export default function DirectFulfillmentRequestForm() {
  const dispatch = useDispatch();
  const {sendingFulfillmentRequest} = useSelector((state: IReduxState) => state.products);
  return (
    <div className="w-full max-w-600 mx-auto my-10 min-h-full-screen scroll-y">
      <BackTo
        link="/fulfillment"
        title={<div className="text-16 font-medium">Fill in the form with your information</div>}
      />
      <Card className="p-5 mb-10 mt-4" elevation={0}>
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            message: ''
          }}
          onSubmit={async (values, {resetForm}) => {
            await sendDirectFulfillmentRequestApi({dispatch, userInfo: values});
            resetForm();
          }}
          validationSchema={
            yup.object({
              firstName: yup
                .string()
                .required('Field is required'),
              lastName: yup
                .string()
                .required('Field is required'),
              email: yup
                .string()
                .email('Enter valid email')
                .required('Field is required'),
              phone: yup
                .number()
                .test('len', 'Enter valid phone number', (val) => val?.toString().length >= 10)
                .required('Field is required'),
              message: yup
                .string()
                .required('Field is required')
            })
          }
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            handleChange
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container>
                <Grid item xs={12} md={6} className="px-3 py-4">
                  <TextField
                    fullWidth
                    required
                    variant="outlined"
                    value={values.firstName}
                    name="firstName"
                    label="First Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.firstName && Boolean(errors.firstName)}
                    helperText={touched.firstName && errors.firstName}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="px-3 py-4">
                  <TextField
                    fullWidth
                    required
                    variant="outlined"
                    value={values.lastName}
                    name="lastName"
                    label="Last Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.lastName && Boolean(errors.lastName)}
                    helperText={touched.lastName && errors.lastName}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="px-3 py-4">
                  <TextField
                    fullWidth
                    required
                    variant="outlined"
                    value={values.email}
                    name="email"
                    label="Email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="px-3 py-4">
                  <NumberFormat
                    customInput={TextField}
                    format="(###) ###-####"
                    mask="_"
                    required
                    className="w-full"
                    label="Phone"
                    variant="outlined"
                    name="phone"
                    value={values.phone}
                    onValueChange={(value) => {
                      setFieldValue('phone', value.floatValue);
                    }}
                    onBlur={handleBlur}
                    error={touched.phone && Boolean(errors.phone)}
                    helperText={touched.phone && errors.phone}
                  />
                </Grid>
                <Grid item xs={12} className="px-3 py-4">
                  <TextField
                    fullWidth
                    required
                    multiline
                    rows="3"
                    variant="outlined"
                    value={values.message}
                    name="message"
                    label="Message"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ className: 'p-0' }}
                    error={touched.message && Boolean(errors.message)}
                    helperText={touched.message && errors.message}
                  />
                </Grid>
              </Grid>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="mx-4 mt-6"
              >
                Submit
              </Button>
            </form>
          )}
        </Formik>
      </Card>
      <BackdropCircular loading={sendingFulfillmentRequest} />
    </div>
  );
}
